module.exports = veItemBulkMfeConfig;